type Prettify<T> = {
    [K in keyof T]: T[K];
} & {};

export type FtpUserID = number;
type SystemUserID = number;
type ServerID = string;
type Password = string;
type HashedPassword = string;
type DirectoryPath = string;
type SystemUserName = string;
type WebsiteID = number;

export enum FtpUserStatus {
  CREATING,
  ACTIVE,
  UPDATING,
  DELETING,
  DELETED,
  ERROR,
  DISABLED,
}

export type FtpUser = {
    id: FtpUserID;
    username: string;
    password: HashedPassword;
    homeDir: DirectoryPath;
    systemUserId: SystemUserID;
    accountName: SystemUserName | null;
    server: ServerID;
    status: FtpUserStatus;
    websiteId: WebsiteID;
}

export type FtpUserLog = {
    id: number;
    log: string;
}

export type FtpUserWithLogs = Prettify<FtpUser & {
    logs: FtpUserLog[];
}>;

export type FtpUserCreateDTO = {
    username: string;
    password: Password;
    systemUserId: SystemUserID;
    server: ServerID;
    websiteId: WebsiteID;
    homeDir: DirectoryPath;
}

export type FtpUserUpdateDTO = {
    password: Password;
}

type URLString = string;

export type FtpUserSearchResult = {
    total: number;
    limit: number;
    offset: number;
    next: URLString | null;
    prev: URLString | null;
    ftpUsers: FtpUser[];
}

export interface FtpUserRepositoryInterface {
    createFtpUser(dto: FtpUserCreateDTO): Promise<FtpUser>;
    updateFtpUser(id: FtpUserID, dto: FtpUserUpdateDTO): Promise<void>;
    deleteFtpUser(id: FtpUserID): Promise<void>;
    searchFtpUsers(page: number, search?: string, itemsPerPage?: number): Promise<FtpUserSearchResult>;
    findOneById(id: FtpUserID): Promise<FtpUserWithLogs>;
}
